// extracted by mini-css-extract-plugin
module.exports = {"custom":"GrayBtn_custom__1VQIh"};